"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _styles = require("@ori-ui/mui-bundle/material/styles");
var _constants = require("../constants");
var styleOverrides = {
    root: {
        backgroundColor: 'transparent'
    },
    dotActive: {
        backgroundColor: _constants.colors.defaultColors.dark,
        transform: 'scale(1.2)'
    },
    dots: {
        alignItems: 'center'
    },
    dot: {
        transition: "transform ".concat(_styles.duration.short, "ms ").concat(_styles.easing.easeInOut, ", box-shadow ").concat(_styles.duration.short, "ms ").concat(_styles.easing.easeInOut, ", background-color ").concat(_styles.duration.short, "ms ").concat(_styles.easing.easeInOut),
        willChange: 'transform, box-shadow, background-color',
        backgroundColor: _constants.colors.oriGrey[400],
        width: 10,
        height: 10,
        margin: '0 5px'
    },
    positionStatic: function(param) {
        var theme = param.theme;
        return {
            color: _constants.colors.text.secondary,
            fontSize: theme.typography.body1.fontSize,
            fontWeight: _constants.font.fontWeightBold
        };
    },
    progress: {
        color: _constants.colors.defaultColors.dark
    }
};
var defaultProps = {
    LinearProgressProps: {
        color: 'inherit'
    }
};
var _default = exports.default = {
    defaultProps: defaultProps,
    styleOverrides: styleOverrides
}; //# sourceMappingURL=MuiMobileStepper.js.map
